import { useUser } from "@/features/auth";
import { User } from "@/features/users";
import { useIsDarkMode } from "@/utils/isDarkMode";
import { useMutation } from "react-query";
import { axios } from "../../../lib/axios";
import { canTrackUser } from "../utils/canTrackUser";
import { getIdentifyTraits } from "../utils/traits";

type TrackEventPayload = {
  event: string;
  properties: string;
  user?: User;
  verified?: boolean;
  isDarkMode?: boolean;
};

export const trackEvent = ({
  event,
  properties,
  user,
  verified,
  isDarkMode,
}: {
  event: string;
  properties: string;
  user: User;
  verified: boolean;
  isDarkMode: boolean;
}): Promise<any> => {
  if (!canTrackUser(user?.username)) {
    return Promise.resolve();
  }

  if (verified === false) {
    return Promise.resolve();
  }

  if (!user.id) {
    return Promise.resolve();
  }

  const traits = getIdentifyTraits(user);

  let propertiesObj;
  try {
    propertiesObj = { ...JSON.parse(properties || "{}"), email: traits.email };
  } catch (error) {
    propertiesObj = { ...traits };
  }
  propertiesObj.beta = true;
  propertiesObj.dark_mode = isDarkMode;
  const updatedProperties = JSON.stringify(propertiesObj);

  return axios.post("/trackUser", {
    event,
    properties: updatedProperties,
    userId: user.id.toString(),
  });
};

export const useTrackEvent = () => {
  const { data: user } = useUser();
  const isDarkMode = useIsDarkMode();

  return useMutation((payload: TrackEventPayload) => {
    return trackEvent({
      ...payload,
      user: user as User,
      verified: user?.verified || false,
      isDarkMode,
    });
  });
};
